export const translationsEN = {
  welcome: "Welcome to ArteOnU!",
  my_account_: "My Account",
  interesed: "You may also be interested in",
  relacioned: "You may also like",
  view: {
    shop: "VIEW SHOP",
    profile: "Edit",
    level: "Level",
    myprofile: {
      my_profile: "My Profile",
      my_benefits: "My Benefits",
      my_info: "My Info",
      name: "Name",
      lastname: "Last Name",
      phone: "Phone",
      email: "Email",
      membership_number: "Fan number",
      edit: "Edit",
      edit_my_profile: "Edit my profile",
      log_out: "Log Out",
      store: "SAVE DATA",
      category: "Level",
      generate_crystals: "51 a 150 crystals ",
      affiliation_number: "Fan Number",
      success: "Data updated correctly",
      unsubscribe: "Unsubscribe here",
      unsubscribe_title: "Want to cancel your Art(e)Fans membership?",
      unsubscribe_text:
        "<p>We'll miss you, but remember: Be free, be happy, be yourself.</p><p>To cancel, email <a href='mailto:info@arteonu.com'>info@arteonu.com</a> from the same email you used to sign up.</p><p><strong>Subject:</strong> I want to cancel my Art(e)Fans membership.</p><p>Include your full name, membership number, and if you’d like, a short note on why you're leaving.</p><p>We'll reply with the cancellation terms. <br>Just respond with:</p><ul style='text-align:center'><li>• 'Yes, proceed with the cancellation', or</li> <li>• 'No, I want to stay'</li></ul><p><strong>Thanks for being part of Art(e)Fans!</strong></p>",
      unsubscribe_confirm: "Close",
    },
    orders: {
      title: "My Orders",
      subtitle: "Shippings, Returns or buy something again",
      view: "VIEW MY ORDERS",
      buynew: "Returns or buy something again.",
      view_item: "View Item",
    },
    address: {
      title: "My Addresses",
      subtitle: "Saved Addresses for the delivery of your purchases",
      edit: "Edit",
      add: "Add",
      address: "Address",
      edit_shipping: "Edit shipping address",
      add_shipping: "Add shipping address",
      street_numer_apt_1: "Line 1",
      street_numer_apt_2: "Line 2",
      postal_code: "Postal Code",
      city: "City/State",
      detail: "Details",
      adddetail: "Add address details",
      update: "UPDATE DATA",
      store: "SAVE DATA",
      delete: "Remove this shipping address",
    },
    loading: "loading...",
  },
  login: {
    title: "Log In",
    titleM: "LOG IN",
    registerM: "REGISTER",
    already_account: "Already have an account?",
    country: "Country",
    name: "Name",
    lastname: "Last Name",
    email: "Email",
    date: "Date of birth",
    date_error: "You must be over 18 years old to register.",
    password: "Password",
    submit: "LOGIN",
    forgotPassword: "Forgot your password?",
    recoverPassword: "Recover Password",
    google: "Continue with Google",
    facebook: "Continue with Facebook",
    wemail: "Continue with Email",
    no_register: "Not registered yet?",
    create: "Create an account",
    password_no: "Incorrect password",
    forgout: "Forgot your password?",
    confirm_email: "Confirm your email address",
    register_success: "Registration successful",
    phone: "Cell phone number",
    term1: "By clicking on “Register” you accept our terms and conditions",
    term2: "Terms and Conditions",
    term3: "Terms of Use",
    term4: "Terms of Service",
    term5: "Privacy Policy",
    term6: "as well as the",
    term7: "Privacy Notice",
    nameplacesholder: "Name official",
    lastnameplacesholder: "Lastname official",
    error1: "You must fill in all fields",
    error2: "Invalid credentials",
    error3: "User authentication failed",
    error4: "You must enter an email",
    error5: "Error sending password recovery email",
    rollback: "Thanks for coming back :D",
    check_spam: "Please also check your spam folder, just in case.",
    resend: "Message successfully resent",
  },
  recovery: {
    enter:
      "Enter the email address you used when you registered to retrieve your password. You will receive a link to reset your password",
    title: "Recover password",
    titleM: "RECOVER PASSWORD",
    change: "Change password",
  },
  shopping: {
    title: "Shopping cart",
    discount_code: "Discount code",
    if_code: "If you have a discount code, enter it here.",
    total_products: "Total products",
    subtotal: "Subtotal",
    discount: "Discount",
    shipping: "Shipping",
    purchased: "MAKE A PURCHASE",
    apply: "APPLY",
  },
  product: {
    detail: "Product details",
    size: "Size",
    color: "Color",
    store: "STORE",
    delete: "Delete",
    edit: "Edit",
    quanty: "Quantity",
    find_size: "Find your size",
    size_description:"Size measurements may vary depending on the product. We invite you to review the following information so you can choose the ideal size for you.",
    select_size: "Select size",
    select_color: "Select color",
    important: "Important",
    size_information:"Size measurements may vary on the product. Please check  “find your size” section and choose the one that will fits you better.",
    no_available: "Product NO AVAILABLE",
    add_cart: "ADD TO CART",
    buy: "BUY NOW",
    leet_me: "LET ME KNOW WHEN IT IS AVAILABLE",
    will_send: "We will send you an email when this product is available.",
    no_stock: "Product out of stock",
    no_stock_layer:"This product is out of stock. You can enter your email and we will send you an email when the product is available again",
    discount: "DISCOUNT",
    link: "Link copied",
    contact:"Do you have any questions or comments about this product SKU {{sku}}?",
    contact2: "Write to us at info@arteonu.com",
    mailto: "mailto:info@arteonu.com?subject=Inquiry about product SKU {{sku}}&body=Hello,%0D%0A%0D%0AI have a question about the product SKU {{sku}}:%0D%0A%0D%0A[Please write your question or comment here]%0D%0A%0D%0ABest regards,",
  },
  checkout: {
    init:'GO TO HOME',
    guest_title: "Buy as guest",
    name: "Name",
    lastname: "Last Name",
    name_placeholder: "Enter your name",
    lastname_placeholder: "Enter your last name",
    email: "Email",
    email_placeholder: "Enter your email",
    login_button: "LOG IN",
    forgot_password: "Forgot your password?",
    recover_password: "Recover password",
    not_registered: "Not registered yet?",
    create_account: "Create account",
    address: "Shipping address",
    stored: "Saved addresses",
    select: "Select where you want to send your order.",
    with_pay:"We offer standard shipping by default, if you want another type of shipping, please contact us.",
    add_address: "ADD ANOTHER ADDRESS",
    edit_address: "Edit",
    continue: "Continue",
    indicated: "Indicate the address where we will send your purchase.",
    information: "Payment information",
    credicard: "Credit or Debit Card",
    card: "Card",
    paypal: "Your payment will be made from your PayPal account",
    success: "Thanks for your support!",
    error: "Payment failed!",
    your_pay_success: "Your payment was successful",
    your_pay_error: "Your payment could not be processed",
    send1: "We have sent an email to ",
    send2: "with the details of your purchase",
    send_error: "Please contact us to resolve the issue.",
    check: "CHECK MY ORDERS",
    continue_shopping: "CONTINUE SHOPPING",
    success_pending: "Payment pending!",
    your_pay_pending: "Your order has been processed correctly.",
    send1_pending: "We have sent you an email to ",
    send2_pending: "with the details of your order.",
    check_spam: "Please also check your spam folder, just in case.",
    register_benefits: "Continue with your registration to enjoy the benefits of Art(e) Fans.",
    venmozelle: "RECEIVE PAYMENT INSTRUCTIONS",
    payzellevenmo:"Payments via Venmo or Zelle must be made in USD. Do you want to change the currency to USD?",
    payzellevenmo_btn: "YES",
    processing_payment: "We are processing your payment",
    dont_close_window: "Please do not close the window",
    pay_now: "Pay Now",
    error_fields: "Please make sure to fill in all fields correctly.",
    contact: "Don't see your country listed? Contact us to arrange shipping.",
  },
  summary: {
    title: "Order Summary",
    see: "View summary",
    gift: "Gift product",
  },
  legal: {
    dudas: "Do you have doubts?",
    contact: "CONTACT US",
    description: "Get in touch with us!",
    category: "GO TO CATEGORIES",
  },
  footer: {
    term1: "Terms & Conditions",
    term2: "Terms of Service",
    term3: "Privacy Policy",
    term4: "Returns & Exchanges ",
    term5: "Size Chart",
    term6: "Shipping Policy",
    term7: "Cookies",
    term8: "ArteOnU All rights reserved 2025",
    term9: "Information",
    term10: "Contact Us",
  },
  home: {
    abouttext: "Who We Are",
    about:
      "Sometimes going through a crisis is a good reason to start something positive. This is how the history of Arte On U began with its founder and Artistic Director, Miguel Pérez Lem. In 2020...",
    about_button: "SEE MORE",
    register: "Sign Up",
    search: "search for a product",
    li1: "10% off your first online order.",
    li2: "Accumulate points and earn benefits",
    li3: "Shopping assistance with the designer",
    li4: "And more",
    li5: "Because every Diva loves her fans — and we wouldn’t dare forget ours. ",
    li6: "Art(e) Fans",
    li7: "is not just a rewards program, it’s your all-access pass to the House of Fabulous. We create this space for your ultimate",
    li8: " “Glow-Up” ",
    li9: "To shine. To slay. To stay gloriously, unapologetically yourself.",
    contact: "Contact us",
  },
  confirmation: {
    email: "Confirm your email",
    send1: "We have sent an email to: ",
    send2: "to confirm  your account.",
    send3:
      "If you don't find that message in your main mail tray please check your spam and promotions folders.",
    send4: "Didn't receive the confirmation email?",
    send5: "Resend email",
    send6: "Forgot your password?",
    send7: "Recover password",
    send8: "with a link to recover your password.",
    send9:
      "If you don't find the message in your primary inbox, check your spam and promotions folders.",
    send10: "Didn't you receive the confirmation email?",
    send11: "Resend email",
    send12: "Send SMS",
    send13: "Back to site",
    send14: "Go",
  },
  collections: {
    send1: "Collections:",
    send2: "All",
    send3: "Vertical",
    send4: "Horizontal",
    send5: "We haven't found anything!",
    send6: "We haven't found anything related to your",
    send7: "search, try using other search terms.",
    send8: "Subcategories:",
  },
  benefits: {
    title: "Art(e)Fans Glow-Ups Rewards",
    redward: "SEE MY REWARDS",
    next: "You are very close to unlocking the next level",
    unlock: "You are very close to unlocking the next level!",
    redem: "Reward redeemed",
    cristals: "Crystals",
    amber: {
      cristals: "51 to 150 Crystals",
      benefits_title_1: "Exclusivity, before anyone else.",
      benefits_description_1:
        "As a valued member of this exclusive tier, you’ll enjoy early access to our new collections—a full one week before the official launch. With our signature limited runs, this is your invitation to claim the pieces that speak to you—before anyone else even knows they exist.",
      benefits_title_2: "Happy Birthday, darling!",
      benefits_description_2:
        "On the most iconic day of the year, we’re not just celebrating your birth—we’re celebrating the fierce, fabulous, 100% authentic you! Get ready for a surprise, because you deserve all the love, sparkle, and extra that day. Stay radiant, stay you!",
      benefits_title_3: "Free Shipping",
      benefits_description_3:
        "Who doesn't love free shipping? Although it's subject to our shipping policies, you'll receive preferential treatment when it's shipped.",
      benefits_title_4: "Exclusive Consulting",
      benefits_description_4:
        "Once a month, enjoy a 30-minute heart-to-heart with our design and image expert—via chat, phone, or video call. It’s your moment to spill the tea  how scandalous your weekend was or plotting how to snatch the heart of your latest crush using one of our dazzling designs, we’re here for it. Bring the drama, bring the desire—we’ll bring the style.",
    },
    emerald: {
      cristals: "151 to 300 Crystals",
      benefits_title_1: "Exclusivity, before anyone else.",
      benefits_description_1:
        "As a valued member of this exclusive tier, you’ll enjoy early access to our new collections—a full two weeks before the official launch. With our signature limited runs, this is your invitation to claim the pieces that speak to you—before anyone else even knows they exist.",
      benefits_title_2: "Happy Birthday, darling!",
      benefits_description_2:
        "On the most iconic day of the year, we’re not just celebrating your birth—we’re celebrating the fierce, fabulous, 100% authentic you! Get ready for a surprise, because you deserve all the love, sparkle, and extra that day. Stay radiant, stay you!",
      benefits_title_3: "Free Shipping",
      benefits_description_3:
        "Who doesn't love free shipping? Although it's subject to our shipping policies, you'll receive preferential treatment when it's shipped.",
      benefits_title_4: "Exclusive Consulting",
      benefits_description_4:
        "Once a month, enjoy a 30-minute heart-to-heart with our design and image expert—via chat, phone, or video call. It’s your moment to spill the tea  how scandalous your weekend was or plotting how to snatch the heart of your latest crush using one of our dazzling designs, we’re here for it. Bring the drama, bring the desire—we’ll bring the style.",
      benefits_title_5: "Second Exclusive Consulting",
      benefits_description_5:
        "The drama isn’t over? Don’t worry, babe—we’ve got you covered. You’re back for round two, and we’re here for all the juicy updates. Spill the tea, unleash the chaos, and let’s keep leveling up your stunning style. We’re talking confidence, killer looks, and head-turning entrances (especially to leave those bitches shook). Because the fabulous never rests.",
      benefits_title_6: "Seasonal Surprise",
      benefits_description_6:
        "We love creating special things for someone as unique as you! Each season, we’ll be sending you a little something to zhuzh up your look and keep you serving all year long. You deserve it, darling!",
    },
    diamond: {
      cristals: "From 301 Crystals",
      benefits_title_1: "Exclusivity, before anyone else.",
      benefits_description_1:
        "As a valued member of this exclusive tier, you’ll enjoy early access to our new collections—a full three weeks before the official launch. With our signature limited runs, this is your invitation to claim the pieces that speak to you—before anyone else even knows they exist.",
      benefits_title_2: "Happy Birthday, darling!",
      benefits_description_2:
        "On the most iconic day of the year, we’re not just celebrating your birth—we’re celebrating the fierce, fabulous, 100% authentic you! Get ready for a surprise, because you deserve all the love, sparkle, and extra that day. Stay radiant, stay you!",
      benefits_title_3: "Free Shipping",
      benefits_description_3:
        "Who doesn't love free shipping? Although it's subject to our shipping policies, you'll receive preferential treatment when it's shipped.",
      benefits_title_4: "Exclusive Consulting",
      benefits_description_4:
        "Once a month, enjoy a 30-minute heart-to-heart with our design and image expert—via chat, phone, or video call. It’s your moment to spill the tea  how scandalous your weekend was or plotting how to snatch the heart of your latest crush using one of our dazzling designs, we’re here for it. Bring the drama, bring the desire—we’ll bring the style.",
      benefits_title_5: "Second Exclusive Consulting",
      benefits_description_5:
        "The drama isn’t over? Don’t worry, babe—we’ve got you covered. You’re back for round two, and we’re here for all the juicy updates. Spill the tea, unleash the chaos, and let’s keep leveling up your stunning style. We’re talking confidence, killer looks, and head-turning entrances (especially to leave those bitches shook). Because the fabulous never rests.",
      benefits_title_6: "Seasonal Surprise",
      benefits_description_6:
        "We love creating special things for someone as unique as you! Each season, we’ll be sending you a little something to zhuzh up your look and keep you serving all year long. You deserve it, darling!",
      benefits_title_7: "Tailored to You",
      benefits_description_7:
        "You’re one of a kind—so why should your clothes be any different? We’re excited to offer you one complimentary tailoring service each month, so your garments fit you just right. Because when something is made for you, it should feel like it. Perfect fit. No extra cost. Just for you.",
    },
  },
  form: {
    title: "CONTACT US",
    message: "Send us a message",
    name: "Name",
    email: "Mail",
    msj: "Message",
    send: "SEND",
    follow: "Follow us!",
    text1: "Form successfully submitted",
    text2: "Thank you for contacting us, we will get back to you shortly.",
    accep: "ACCEPT",
  },
  cart: {
    title1: "Product added",
    title2: "to cart",
    title3: "There are",
    title4: "items in your cart totaling:",
    title5: "VIEW CART",
    title6: "CONTINUE SHOPPING",
    error1: "Enter a valid code",
    addcod: "Code entered correctly",
    error3: "You must have items in your cart to use this code",
    error4: "Enter a valid code",
  },
  error: {
    size: "You must select a size",
    quanty: "Add a valid quantity",
    address: "you must select an address",
    address_continue:"You must save the  ındress before continuing",
    addressd: "An error occurred while saving the address",
    addresse: "Address successfully saved",
    addresde: "Address successfully deleted",
    addresmo: "It is not possible to remove the address at the moment",
    addressnoa: "Address not available",
    ar: "The address field is required",
    cp: "The postal code must be an integer",
    city: "The city field is required",
    field: "Fields are missing",
    geral: "An error occurred, please try again later",
    no_fa: "Could not add to favorites",
    pass: "The keys do not match",
    passe: "Error attempting to change password",
    date_birth: "You must enter your date of birth to continue",
  },
  orders: {
    id: "Order ID",
    realized: "Order placed on",
    hide: "Hide Details",
    show: "Details",
    address: "Shipping address",
    status: "Status",
    track: "Track shipment",
    policies: "Exchange and Return Policies",
    details: "Order details",
    code: "Discount code",
    products: "Products",
    shipping: "Shipping",
    promotion: "Promotion applied",
    inorder: "Products in order",
  },
  wishlist: {
    articles: "items",
    list: "Wishlist",
    noavailable: "Favorites list not available",
    noadd: "Could not add to favorites",
  },
  categories: {
    our_artists: "Our Artists",
    our_artists_uri: "our-artists",
  },
  stripe: {
    error1: "Checkout not available, try again",
    error2: "Stripe not available",
  },
};